module.exports = __webpack_public_path__ + "static/media/lm_payrollTicket_pattern_50.e48779fb.jpg";